import React, { FC } from 'react';
import '../../style/style.scss';

interface Props {
    subtitle: string
}

const SubtitlePage : FC<Props> = (props) => {
  return (
    <section className="container subtitle-page">
      <h2 className="h2">{ props.subtitle }</h2>
    </section>
  );
};
export default SubtitlePage;